
import { Component, Prop, Vue } from 'vue-property-decorator';

const DEFAULT_FILL = 'var(--neutralcolor-low-pure)';

@Component
export default class Information extends Vue {
  @Prop({ default: DEFAULT_FILL }) fill!: string;
  @Prop({ default: '22' }) width!: string;
  @Prop({ default: '19' }) height!: string;
}
